import type { IconSvgObject } from './types';

const SendToBackIcon: IconSvgObject = [
  ["path", { d: "M2 8.5V3.5C2 2.67157 2.67157 2 3.5 2H8.5C9.32843 2 10 2.67157 10 3.5V8.5C10 9.32843 9.32843 10 8.5 10H3.5C2.67157 10 2 9.32843 2 8.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 20.5V15.5C14 14.6716 14.6716 14 15.5 14H20.5C21.3284 14 22 14.6716 22 15.5V20.5C22 21.3284 21.3284 22 20.5 22H15.5C14.6716 22 14 21.3284 14 20.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 6H16C17.1046 6 18 6.89543 18 8V10M6 14V16C6 17.1046 6.89543 18 8 18H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SendToBackIcon;
